import React from 'react'
import { makeStyles } from '@mui/styles'
import request from '@/modules/base/util/request'

import lang from '@/lang'
import accountConfig from '@/modules/account/config'
import { ButtonNext } from '@/modules/base/components/buttons/index'
import ApproveWrapper from './approve-wrapper'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { useNavigate } from 'react-router'

const Resend = (props) => {
  const navigate = useNavigate()
  const { email } = props
  const classes = useStyles()

  const handleSubmitFailure = (response) => {
    const { xhr } = response
    let message = lang.defaultErrorMessage

    if (!xhr) {
      return toast.showToast({ type: 'error', message })
    }

    const { body: { meta: { email } } } = response

    if (email) {
      const [{ code }] = email
      switch (code) {
        case 'INVALID':
          message = lang.approveResendEmailInvalidMessage
          break
        default:
          message = lang.defaultErrorMessage
          break
      }
    }

    toast.showToast({ type: 'error', message })
  }

  const handleSubmitSucces = () => {
    toast.showToast({ message: lang.approveResendSuccessMessage })
    navigate('/account/login')
  }

  const submitCallback = (event) => {
    event.preventDefault()

    request(accountConfig.endpoints.resendRegistrationEmail, { method: 'PUT', data: { email } })
      .then(handleSubmitSucces)
      .catch(handleSubmitFailure)
  }

  return (
    <ApproveWrapper title={lang.approveResendTitle} showLoginLink>
      <div>
        <p className={classes.subtitle}>{lang.approveResendDescription1} {lang.approveResendDescription2}</p>
        <ButtonNext
          label={lang.approveResendButtonLabel}
          customClass={classes.loginButton}
          onClick={submitCallback} />
      </div>
    </ApproveWrapper>
  )
}

const useStyles = makeStyles(theme => ({
  subtitle: {
    textAlign: 'center',
  },
  loginButton: {
    width: '100%',
    marginTop: '15px',
  },
}))

export default Resend
